import { styled as r } from "styled-components";
import { Colors as i } from "../../../styles/colors/index.js";
import { SmallHeavy as t, FontFamily as e } from "../../../styles/typography/index.js";
import { Icon as l } from "../../../components/Icon/index.js";
import { Theme as o } from "../../../styles/themes/index.js";
const s = r.div`
  ${t}
  display: flex;
  align-items: center;
  max-width: 21px;
  height: 16px;
  padding: 2px 3px;
  position: absolute;
  top: -2px;
  right: -4px;
  border-radius: 8px;
  background-color: rgb(${i.Red});
  border: 2px solid rgb(${o.colors.Juliet});

  font-size: 11px;
  line-height: 16px;
  color: rgb(${i.Porcelain});
  font-family: ${e.DM_SANS};
`, g = r.div`
  --borderColor: rgb(${o.colors.Golf});

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  position: relative;
  border-radius: 50%;
  background: none;
  background-color: rgb(${o.colors.Juliet});
  border: 2px solid var(--borderColor);
  width: 40px;
  height: 40px;

  &:hover {
    background-color: rgb(${o.colors.Kilo});
  }
`, x = r(l)`
  color: rgb(${o.colors.Alpha});
  && {
    font-size: 24px;
  }
`;
export {
  s as NotificationBadge,
  x as NotificationBarBellIcon,
  g as NotificationBarIconContainer
};
